
import Vue from 'vue';
import { ROUTER } from '@/router/constants';
import { mapGetters, mapState } from 'vuex';
import CompanySettingsOverview from '@/views/Team/CompanySettings/CompanySettingsOverview.vue';
import EditCompany from '@/views/Team/TeamDashboard/EditCompany/EditCompany.vue';
import { TeamUserMixin } from '@/mixins/TeamUserMixin';
import EnterpriseUpsellBadge from '@/components/EnterpriseUpsellWrapper/EnterpriseUpsellBadge.vue';

export default Vue.extend({
	name: 'CompanySettings',
	components: {
		EnterpriseUpsellBadge,
		CompanySettingsOverview,
		EditCompany,
	},
	metaInfo () {
		return {
			title: `Company Settings | ${this.team?.company?.name || 'Company'} | RunDiffusion`,
		};
	},
	data () {
		return {
			showEditCompanyDialog: false,
		};
	},
	mixins: [
		TeamUserMixin,
	],
	computed: {
		...mapState([
			'team',
			'user',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
	},
	methods: {
		onTeamRolesClick () {
			this.$router.push({ name: ROUTER.TEAM_ROLES });
		},
		onCompanyRolesClick () {
			this.$router.push({ name: ROUTER.COMPANY_ROLES });
		},
		onScimClick () {
			this.$router.push({ name: ROUTER.COMPANY_SETTINGS_SSO_SCIM });
		},
	},
});
